import { Component, OnInit, ViewChild, Output, EventEmitter, Input, ElementRef, TemplateRef } from '@angular/core';
import { Subject ,  Observable } from 'rxjs';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';
import { BsModalService } from 'ngx-bootstrap/modal';

@Component({
  selector: 'bz-confirm-dialog',
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent implements OnInit {

  public confirmDialogResponse$ : Subject<boolean> = new Subject<boolean>();

  public modalRef: BsModalRef;
  @ViewChild('confirmDialog', { static: false}) confirmDialog: TemplateRef<any>;

  @Input() public title : string;
  @Input() public message : string;
  @Input() public displayAccept = 'ACCEPT';
  @Input() public displayReject = 'CANCEL';
  @Input() public type = 'accept';
  @Output() onAccept: EventEmitter<void> = new EventEmitter<void>();
  @Output() onCancel: EventEmitter<void> = new EventEmitter<void>();

  constructor(private modalService: BsModalService) { }

  ngOnInit() { }

  accept() {
    this.confirmDialogResponse$.next(true);
    this.onAccept.emit();
    this.modalRef.hide();
  }
  cancel() {
    this.confirmDialogResponse$.next(false);
    this.onCancel.emit();
    this.modalRef.hide();
  }

  showDialog() : Subject<boolean>{
    this.modalRef = this.modalService.show(this.confirmDialog);
    return this.confirmDialogResponse$;
  }
  getType(){
    return 'modal-'+this.type+'-action'
  }
  hideDialog(){
    this.modalRef.hide();
  }
  
}
